import './CustomReportActionButton.scss'
export const CustomReportActionButton = ({ onClick, children, disabledState = false, customClass = '' }) => {
  return (
    <button
      disabled={disabledState}
      onClick={() => {
        onClick()
      }}
      className={`svg-button ${customClass || ''}`.trim()}
    >
      {children}
    </button>
  )
}

export default CustomReportActionButton
